import React from 'react';

import IMG_BRIGHT_MODE from 'assets/images/salon/bright-mode.png';
import IMG_DARK_MODE from 'assets/images/salon/dark-mode.png';
import IMG_LIGHT_MODE from 'assets/images/salon/light-mode.png';
import ImageOptionsInput from 'components/form/ImageOptionsInput.component';
import THEME_MODE from 'constants/themeMode.const';
import { useTranslation } from 'providers/GILT.provider';
import C from 'utils/values/constant.util';

const OPTIONS = C([
  {
    id: THEME_MODE.light,
    descriptionTranslateKey: 'staffAndBusiness.calendarSettings.lightMode',
    src: IMG_LIGHT_MODE,
  },
  {
    id: THEME_MODE.bright,
    descriptionTranslateKey: 'staffAndBusiness.calendarSettings.brightMode',
    src: IMG_BRIGHT_MODE,
  },
  {
    id: THEME_MODE.dark,
    descriptionTranslateKey: 'staffAndBusiness.calendarSettings.darkMode',
    src: IMG_DARK_MODE,
  },
]);

const ColorMode = (props) => {
  const { t } = useTranslation();

  const translatedOptions = OPTIONS.map((option) => ({
    ...option,
    description: t(option.descriptionTranslateKey),
  }));

  return <ImageOptionsInput {...props} options={translatedOptions} columns="three" variant="contain" />;
};

export default ColorMode;
